import { ApiAddress } from '@/services/apis'
import request from '@/services/request'

export function uploadFile(file, type?): Promise<{ url: string }> {
  const body = new FormData()
  body.set('file', file)
  if (type) {
    body.set('type', type)
  }
  return request.post(ApiAddress.STATIC_FILES, body)
}

export function uploadAvatar(body: FormData): Promise<{url: string}> {
  return request.post(ApiAddress.AVATARS, body)
}
